import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/query/react';
import { useInjectReducer } from 'utils/redux-injectors';
import { State } from './types';
import { endpoints, baseQuery } from 'utils/api/endpoints';

export const initialState: State = {};

const slice = createSlice({
  name: 'downloadsHistory',
  initialState,
  reducers: {
    someAction(state, action: PayloadAction<any>) {},
  },
});

export const api = createApi({
  reducerPath: 'downloadsHistoryApi',
  baseQuery,
  tagTypes: ['DownloadsHistory'],
  endpoints: builder => ({
    getDownloadsHistory: builder.query<any, any>({
      query: filters => ({
        url: endpoints.DOWNLOADS_HISTORY + '/list',
        method: 'GET',
        params: filters,
      }),
      providesTags: ['DownloadsHistory'],
    }),
    getFileDownloadHistory: builder.query<any, any>({
      query: filters => ({
        url: endpoints.DOWNLOADS_HISTORY + '/file',
        method: 'GET',
        params: filters,
      }),
    }),
    deleteFileDownloadHistory: builder.mutation<any, any>({
      query: downloadId => ({
        url: endpoints.DOWNLOADS_HISTORY + '/file/delete/' + downloadId,
        method: 'DELETE',
      }),
      invalidatesTags: ['DownloadsHistory'],
    }),
  }),
});

export const { actions: DownloadsHistoryActions } = slice;

export const useDownloadsHistorySlice = () => {
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
  return {
    actions: DownloadsHistoryActions,
    useGetDownloadsHistoryQuery: api.useLazyGetDownloadsHistoryQuery,
    useGetFileDownloadHistory: api.useLazyGetFileDownloadHistoryQuery,
    useDeleteFileDownloadHistoryMutation:
      api.useDeleteFileDownloadHistoryMutation,
  };
};
